/*
  Contact Form
*/

class ContactForm {
  constructor(app, form_id = "contact_form") {
    this.app = app;
    this.form = document.getElementById(form_id);
    this.fields = {};
    // this._self = this;
    this.init();
  }

  init = () => {
    // console.log("App.init.ContactForm:",this.form);

    this.message_box = document.getElementById("message_box");
    this.message = document.getElementById("message");
    this.close = document.getElementById("form_close");

    this.fields = Array.prototype.slice.apply(
      this.form.querySelectorAll("[name]")
    );

    this.fields.forEach((field) => {
      // console.log("FOR:",field)
      if (!this.fields.hasOwnProperty(field)) {
        // console.log("field",field)
        this.fields[field.name] = field;
      }
    });
    // console.log("Fields:", this.fields);
    // console.log("this____",this.fields)
    // Displays all error messages and adds 'error' classes to the form fields with
    // failed validation.
    this.form.addEventListener("submit", this.submit.bind(this));
    this.close.addEventListener("click", this.closeMessage.bind(this));

    // addEventListener('DOMContentLoaded',  this.initGUI.bind(app,this) );
    // Contact
    this.fields["fullname"].addEventListener("click", function () {
      app.gui.contact_container.classList.add("is-focused");
    });
  };

  submit(e) {
    e.preventDefault();
    // alert("son")
    // console.log("submit", this);
    var request = new XMLHttpRequest();
    request.open("POST", e.target.action);
    request.onload = this.onLoad.bind(this);
    // function(e){
    //   alert("okokoko")
    //   console.log("this",this)
    // }
    request.send(new FormData(e.target));
    // Remove all 'error' classes of a possible previously failed validation.
    for (var key in this.fields) {
      // Hide and reset all warnings
      // console.log("___key:", key);

      this.fields[key].classList.remove("is-danger");
      if (key.length > 1) {
        //  document.getElementById('e_' + key).classList.add('is-hidden');
      }
      // console.log(key)
    }
  }

  closeMessage(e) {
    e.preventDefault();
    // alert("son")
    this.message_box.classList.add("is-hidden");
    // this.form.classList.remove('is-hidden');

  }

  onLoad(e, self) {
    // console.log("Form.onLoad", e);
    // console.log("Form.this", this);
    if (e.target.status === 200) {
      let resp = JSON.parse(e.target.response);
      let msg = "";
      // console.log("ele:", resp);

      for (var key in resp) {
        // console.log(key, resp[key]);
        if (key !== "status") {
          msg += resp[key] + "<br/>";
          this.message_box.classList.add("is-danger");
          
        }else{
          if(resp[key] === "200"){
            msg += resp[key] + "<br/>";
            this.message_box.classList.remove("is-danger");
            this.message_box.classList.add("is-ok");
            this.form.reset();
          }
        }
      }

      this.message.innerHTML = msg;

      this.message_box.classList.remove("is-hidden");
      // this.message_box.classList.remove("is-danger");
      // this.form.reset();
      // this.form.classList.add('is-hidden');
    } else {
      this.handleError(JSON.parse(e.target.response));
    }
  }

  handleError(response) {
    var errors = [];
    this.message_box.classList.add("is-danger");
    this.message.innerHTML = "";
    // for (var key in this.fields) {
      // if (!this.fields.hasOwnProperty(key)) continue;
      // console.log(key);
      // document.getElementById('e_' + key).classList.remove('is-danger');
    // }
    // console.log("resp:", response);
    for (var key in response) {
      if (!response.hasOwnProperty(key)) continue;
      if (this.fields.hasOwnProperty(key)) {
        this.fields[key].classList.add("is-danger");

        // Tum hata mesajlar tepedeki kırmızı kutuda
        // this.message.innerHTML += ('' +response[key] + '<br>' );
        this.message.innerHTML = "Please check errors";

        let el = document.getElementById("e_" + key);
        if (el) {
          el.classList.remove("is-hidden");
          el.innerHTML = response[key];
        }

        Array.prototype.push.apply(errors, response[key]);
      }
    }
    // console.log("resp:", response);
    // message.innerHTML = errors.join('<br>');
  }

  // get fullName(){
  //    console.log('inside getter')
  //    return this.fname + " - "+this.lname
  // }
  // set rollno(newRollno){
  //  console.log("inside setter")
  //  this.rno = newRollno
  // }
  //
}

export default ContactForm;
